const STATE_KEY = 'state';
const ENV_KEY = 'env';

const authStorage = {
  getEnv: () => window.localStorage.getItem(ENV_KEY),

  setEnv: value => window.localStorage.setItem(ENV_KEY, value),

  removeEnv: () => window.localStorage.removeItem(ENV_KEY),

  getPersistedState: () => {
    try {
      const serialized = window.localStorage.getItem(STATE_KEY);
      return serialized ? JSON.parse(serialized) : undefined;
    } catch {
      return undefined;
    }
  },

  setPersistedState: state => {
    try {
      window.localStorage.setItem(STATE_KEY, JSON.stringify(state));
    } catch (err) {
      console.error('Failed to persist state:', err.message);
    }
  },

  removePersistedState: () => window.localStorage.removeItem(STATE_KEY),

  getAuthDetails: () => {
    try {
      return JSON.parse(window.localStorage.getItem(STATE_KEY))?.auth ?? null;
    } catch {
      return null;
    }
  },

  clear: () => {
    window.localStorage.removeItem(STATE_KEY);
    window.localStorage.removeItem(ENV_KEY);
  },

  clearAll: () => {
    window.localStorage.clear();
    window.sessionStorage.clear();
  },
};

export default authStorage;
